module.exports = __webpack_public_path__ + "media/images/left-1474f0fb.png";